import React from "react";
// import KMsolution_white from "../images/KMsolution_white.svg";
import KMsolution_black from "../images/KMsolution_black.svg";

function Footer() {
    return (
        <footer>
            <p>
                Questa pagina è stata creata da
                <a href="https://kmsolution.it" target="_blank" rel="noreferrer">KMsolution</a>
                in collaborazione con
                <a href="https://imsagency.it" target="_blank" rel="noreferrer">IMS Agency</a>
            </p>
            <a href="https://kmsolution.it" target="_blank" rel="noreferrer">
                <img src={KMsolution_black} alt="KMsolution" className="h-8 mx-auto" />
            </a>
        </footer>
    );
}

export default Footer;